import { ITimeAmount } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";
import { ValueSign } from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";

interface ITimeAmountWithSign {
  timeAmount: ITimeAmount;
  valueSign: ValueSign;
}

type TimeUnit = "days" | "hours";

/**
 * Formats a time amount with its sign (+ or -) based on the specified unit (days or hours)
 *
 * @param timeAmount - Object containing timeAmount and valueSign
 * @param unit - The time unit to display ("days" or "hours")
 * @returns Formatted string with sign and value (e.g., "+26" or "-8")
 */
export default (
  timeAmountWithSign: ITimeAmountWithSign | null | undefined,
  unit: TimeUnit
): string => {
  if (!timeAmountWithSign) return "-";

  const { timeAmount, valueSign } = timeAmountWithSign;

  if (!timeAmount) return "-";

  const value = timeAmount[unit];

  if (!value) return "-";

  const sign = valueSign === ValueSign.POSITIVE ? "+" : "-";

  return `${sign}${value}`;
};
